import { useLocation } from 'react-router-dom';

import appRoutes from '../../../routes';

const useMeloLocation = () => {
  const { pathname } = useLocation();
  const currentPath = appRoutes.platform.find(({ basePath, path }) => pathname.includes(basePath || path));
  const avoidGlobalLoading = currentPath?.globalLoading === false;
  const currentPathAvoidModals = currentPath?.showFirstModals === false;

  return { avoidGlobalLoading, currentPathAvoidModals };
};

export default useMeloLocation;
